export enum Region {
    Disabled = 'Disabled',
    US1 = 'US1',
    EU1 = 'EU1'
}
